import Vue from 'vue'
import Router from 'vue-router'

// 菜单
import Index from '@/views/index'
import tech from '@/components/tech'
import product from '@/components/product'
import about from '@/components/about'
import cardiobrain from '@/components/cardiobrain'
import retirement from '@/components/retirement'
import ctimaging from '@/components/ctimaging'
import rppghealth from '@/components/rppghealth'


import healthycockpit from '@/components/healthycockpit'
import news from '@/components/news'
import features from '@/components/features'
import topic from '@/components/topic'
import pdf from '@/components/pdf'
import zhpdf from '@/components/zhpdf'
import healthy from '@/components/healthy'
import ica from '@/views/ica'
import PieChart from '@/views/selfTest/PieChart'
import login from '@/views/login/login'
import forget from '@/views/login/forget'
import register from '@/views/login/register'
import resetPassword from '@/views/login/resetPassword'
import passwordSuccess from '@/views/login/passwordSuccess'
import registerTwo from '@/views/login/registerTwo'
import registerSuccess from '@/views/login/registerSuccess'
import healthRecords from '@/views/personCenter/healthRecords'
import realNameAuth from '@/views/personCenter/realNameAuth'
import zizhiAuth from '@/views/personCenter/zizhiAuth'
import zizhiAuthJigou_jbxx from "@/views/personCenter/zizhiAuthJigou_jbxx";
import zizhiAuthJigou_xgzz from "@/views/personCenter/zizhiAuthJigou_xgzz";
import jsgou_submitShenhe from "@/views/personCenter/jsgou_submitShenhe"
import zizhiAuthZj_smrz from '@/views/personCenter/zizhiAuthZj_smrz'
import zizhiAuthZj_jianjie from '@/views/personCenter/zizhiAuthZj_jianjie'
import zj_submitShenhe from "@/views/personCenter/zj_submitShenhe"
import changePass from "@/views/personCenter/changePass"
import znjcIndex from '@/views/personCenter/znjcIndex'
import questionnaire from '@/views/personCenter/questionnaire'
import znjcTable from '@/views/personCenter/znjcTable'
import aizbIndex from '@/views/personCenter/aizbIndex'
import memberCenter from '@/views/personCenter/memberCenter'
import signrecord from '@/views/personCenter/signrecord'
import personCenter from '@/views/personCenter/personCenter'
import iamPromoter from '@/views/personCenter/iamPromoter'
import znjcQsfx from '@/views/personCenter/znjcQsfx'
import aizbTable from '@/views/personCenter/aizbTable'
import xinliQuestion from '@/views/personCenter/xinliQuestion'
import paizheng from '@/views/personCenter/paizheng'
import myOrder from "@/views/personCenter/myOrder";
import fsHistroyChange from "@/views/personCenter/fsHistroyChange";
import shouyichange from "@/views/personCenter/shouyichange";
Vue.use(Router)
//https://segmentfault.com/q/1010000015875314

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)

}

const router = new Router({
  mode: "history",
  routes: [
    {
      path: '/',
      component: Index,
      meta: {
        title: '医学生物特征认知专家_吾征AI官网',
        content: {
          keywords: '高血压手表，血糖仪，血压仪，慢性病，辅助诊断，健康管理app，饮食管理app',
          description: '吾征AI-医学生物特征认知计算系统,致力于利用医学生物特征计算AI技术把“望闻问切”搬上互联网,从“衣食住行”助推健康生活,用户可自行进行诊断，健康管理、饮食管理。',
        },
      }
    },
    {
      path: '/healthy',
      component: healthy,
      meta: {
        title: '吾征AI-认知大脑-用AI认知计算技术,配合人类进行健康和医疗诊断,分析工作',
        content: {
          keywords: '智能认知,认知算法,人工智能,大数据,健康管理,大健康,疾病筛查,辅助诊疗,健康平台,健康管理',
          description: '吾征智能技术(北京)有限公司是一家以AI疾病筛查和辅助诊疗平台为主体,以中文语义认知计算技术为基础,以大健康AIOT产业生态为发展方向的健康智能认知技术公司',
        },
      }
    },
    {
      path: '/tech',
      component: tech,
      meta: {
        title: '吾征AI-技术介绍-实现疾病与健康智能认知自我诊断',
        content: {
          keywords: '中西医结合,望闻问切,认知智能,中文语义,认知算法,大数据',
          description: '中文矩阵式认知计算,全品类健康智能认知系统,疾病病理认知指标诊断,体相语义认知特征智能识别,疾病早期智能筛查方法,临床症状特征权重推导疾病概率',
        },
      }
    },
    {
      path: '/product',
      component: product,
      meta: {
        title: '吾征AI-产品与服务-领先的家庭与社区疾病健康智能筛查与监护平台',
        content: {
          keywords: '侏罗纪,AIOT,智能认知芯片,IOT,室内温湿度,消毒棒,健康管理,疾病筛查技术,早筛',
          description: '人体认知诊断分析系统,体相、征兆、病理、生理、心理、血压、血糖、尿酸、血脂、血氧认知与疾病筛查,AIOT智能认知管理系统,环境与疾病预警预测系统',
        },
      }
    },
    {
      path: '/news',
      component: news,
      meta: {
        title: '吾征AI-新闻中心-用AI认知计算技术,配合人类进行健康和医疗诊断,分析工作',
        content: {
          keywords: '智能认知,认知大脑,机器像人类一样思维,中文语义分析',
          description: 'AI健康认知大脑,让机器变得更智能',
        },
      }
    },
    {
      path: '/features',
      component: features,
      meta: {
        title: '吾征AI-订制中心-用AI认知计算技术,配合人类进行健康和医疗诊断,分析工作',
        content: {
          keywords: '智能认知,认知大脑,机器像人类一样思维,中文语义分析',
          description: 'AI健康认知大脑,让机器变得更智能',
        },
      }
    },
    {
      path: '/topic',
      component: topic,
      meta: {
        title: '吾征AI-订制中心-用AI认知计算技术,配合人类进行健康和医疗诊断,分析工作',
        content: {
          keywords: '智能认知,认知大脑,机器像人类一样思维,中文语义分析',
          description: 'AI健康认知大脑,让机器变得更智能',
        },
      }
    },
    {
      path: '/pdf',
      component: pdf,
      meta: {
        title: '吾征AI-订制中心-用AI认知计算技术,配合人类进行健康和医疗诊断,分析工作',
        content: {
          keywords: '智能认知,认知大脑,机器像人类一样思维,中文语义分析',
          description: 'AI健康认知大脑,让机器变得更智能',
        },
      }
    },
    {
      path: '/zhpdf',
      component: zhpdf,
      meta: {
        title: '吾征AI-订制中心-用AI认知计算技术,配合人类进行健康和医疗诊断,分析工作',
        content: {
          keywords: '智能认知,认知大脑,机器像人类一样思维,中文语义分析',
          description: 'AI健康认知大脑,让机器变得更智能',
        },
      }
    },
    {
      path: '/about',
      component: about,
      meta: {
        title: '吾征AI-关于我们-大健康智能生活主流品牌',
        content: {
          keywords: '吾征AI，人工智能，智能认知',
          description: '为千万个家庭健康管理设备,5亿个疾病与环境终端检测仪器(血糖仪,血压仪等)提供智能化认知服务',
        },
      }
    },
    {
      path: '/cardiobrain',
      component: cardiobrain,
      meta: {
        title: '吾征AI-心脑血管',
        content: {
          keywords: '吾征AI，人工智能，智能认知',
          description: '为千万个家庭健康管理设备,5亿个疾病与环境终端检测仪器(血糖仪,血压仪等)提供智能化认知服务',
        },
      }
    },
    {
      path: '/retirement',
      component: retirement,
      meta: {
        title: '吾征智慧康养系统',
        content: {
          keywords: '吾征AI，人工智能，智能认知',
          description: '筛查、监护、预警、救援 一体化的康养服务',
        },
      }
    },
    {
      path: '/ctimaging',
      component: ctimaging,
      meta: {
        title: 'CT影像文本智能 解读系统',
        content: {
          keywords: '吾征AI，人工智能，智能认知',
          description: '透过影像文本解读身体真相',
        },
      }
    },
     {
      path: '/rppghealth',
      component: rppghealth,
      meta: {
        title: '非接触远程健康监控和大规模数字健康检测系统',
        content: {
          keywords: '吾征AI，人工智能，智能认知',
          description: '非接触远程健康监控和大规模数字健康检测',
        },
      }
    },
    {
      path: '/faceone',
      component:() => import("@/components/faceone"),
      meta: {
        title: '人脸分析生命体征监测',
        content: {
          keywords: '吾征AI，人工智能，智能认知',
          description: '人脸分析生命体征监测',
        },
      }
    },
     {
      path: '/healthycockpit',
      component: healthycockpit,
      meta: {
        title: '吾征健康智能驾舱系统',
        content: {
          keywords: '吾征AI，人工智能，智能认知',
          description: '吾征健康智能驾舱系统',
        },
      }
    },
    {
      path: '/ica',
      component: ica,
      meta: {
        title: '吾征AI-智能认知分析-认知诊断-健康认知报告',
        content: {
          keywords: '表征,症状,认知算法,健康认知报告',
          description: '表征选择及症状描述,智能认知算法生成健康认知包括',
        },
      }
    },
    {
      path: '/pie',
      component: PieChart
    },
    {
      path: '/login',
      component: login,
      meta: {
        title: '用户登录-吾征AI,您的健康智能认知专家'
      }
    },
    {
      path: '/forget',
      component: forget,
      meta: {
        title: '忘记密码-吾征AI,您的健康智能认知专家'
      }
    },
    {
      path: '/register',
      component: register,
      meta: {
        title: '注册-吾征AI,您的健康智能认知专家'
      }
    },
    {
      path: '/resetPassword',
      component: resetPassword,
      meta: {
        title: '重置密码-吾征AI,您的健康智能认知专家'
      }
    },
    {
      path: '/passwordSuccess',
      component: passwordSuccess,
      meta: {
        title: '密码设置成功-吾征AI,您的健康智能认知专家'
      }
    },
    {
      path: '/registerTwo',
      component: registerTwo,
      meta: {
        title: '注册-吾征AI,您的健康智能认知专家'
      }
    },
    {
      path: '/registerSuccess',
      component: registerSuccess,
      meta: {
        title: '注册成功-吾征AI,您的健康智能认知专家'
      }
    },

    //  个人中心-首页
    {
      path: '/personCenter',
      component: personCenter,
      meta: {
        title: '个人中心-吾征AI,您的健康智能认知专家'
      },
      redirect: '/personCenter/healthRecords',
      children: [
        //  个人中心1-1健康档案
        {
          path: '/personCenter/healthRecords',
          component: healthRecords,
          meta: {
            title: '个人中心-健康档案-吾征AI,您的健康智能认知专家'
          }
        },
        //个人中心-1-2-实名认证
        {
          path: '/personCenter/realNameAuth',
          component: realNameAuth,
          meta: {
            title: '个人中心-实名认证-吾征AI,您的健康智能认知专家'
          }
        },
        //个人中心-1-3-资质认证
        {
          path: '/personCenter/zizhiAuth',
          component: zizhiAuth,
          meta: {
            title: '个人中心-资质认证-吾征AI,您的健康智能认知专家'
          }
        },
        //个人中心-1-3-资质认证-机构-基本信息
        {
          path: '/personCenter/zizhiAuth/zizhiAuthJigou_jbxx',
          component: zizhiAuthJigou_jbxx,
          meta: {
            title: '个人中心-机构认证-吾征AI,您的健康智能认知专家'
          }
        },
        //个人中心-1-3-资质认证-机构-相关资质
        {
          path: '/personCenter/zizhiAuth/zizhiAuthJigou_xgzz',
          component: zizhiAuthJigou_xgzz,
          meta: {
            title: '个人中心-机构认证-吾征AI,您的健康智能认知专家'
          }
        },
        //个人中心-1-3-资质认证-机构-提交审核
        {
          path: '/personCenter/zizhiAuth/jsgou_submitShenhe',
          component: jsgou_submitShenhe,
          meta: {
            title: '个人中心-机构认证审核-吾征AI,您的健康智能认知专家'
          }
        },
        //个人中心-1-3-资质认证-专家-实名认证
        {
          path: "/personCenter/zizhiAuth/zizhiAuthZj_smrz",
          component: zizhiAuthZj_smrz,
          meta: {
            title: '个人中心-专家认证-吾征AI,您的健康智能认知专家'
          }
        },
        //个人中心-1-3-资质认证-专家-简介
        {
          path: "/personCenter/zizhiAuth/zizhiAuthZj_jianjie",
          component: zizhiAuthZj_jianjie,
          meta: {
            title: '个人中心-专家认证-吾征AI,您的健康智能认知专家'
          }
        },
        //个人中心-1-3-资质认证-专家-提交审核
        {
          path: '/personCenter/zizhiAuth/zj_submitShenhe',
          component: zj_submitShenhe,
          meta: {
            title: '个人中心-专家认证审核-吾征AI,您的健康智能认知专家'
          }
        },
        //个人中心-1-4-修改密码
        {
          path: '/personCenter/changePass',
          component: changePass,
          meta: {
            title: '个人中心-修改密码-吾征AI,您的健康智能认知专家'
          }
        },
        //个人中心-2-1-智能监测
        {
          path: '/personCenter/znjcIndex',
          component: znjcIndex,
          meta: {
            title: '个人中心-智能监测-吾征AI,您的健康智能认知专家'
          }
        },
        //个人中心-2-1-智能监测 微问卷
        {
          path: '/personCenter/questionnaire',
          component: questionnaire,
          meta: {
            title: '个人中心-智能监测-吾征AI,您的健康智能认知专家'
          }
        },
        //znjcTable
        //个人中心-2-1-智能监测-列表
        {
          path: '/personCenter/znjcIndex/znjcTable',
          component: znjcTable,
          meta: {
            title: '个人中心-智能监测列表-吾征AI,您的健康智能认知专家'
          }
        },
        //个人中心-2-1-智能监测-趋势分析
        {
          path: '/personCenter/znjcIndex/znjcQsfx',
          component: znjcQsfx,
          meta: {
            title: '个人中心-智能监测趋势分析-吾征AI,您的健康智能认知专家'
          }
        },
        //aizbIndex.vue
        //个人中心-2-2-AI诊病
        {
          path: '/personCenter/aizbIndex',
          component: aizbIndex,
          meta: {
            title: '个人中心-AI诊病-吾征AI,您的健康智能认知专家'
          }
        },
        {
          path: '/personCenter/aizbIndex/aizbTable',
          component: aizbTable,
          meta: {
            title: '个人中心-AI诊病-吾征AI,您的健康智能认知专家'
          }
        },
        {
          path: '/personCenter/xinliQuestion',
          component: xinliQuestion,
          meta: {
            title: '个人中心-心理问卷-吾征AI,您的健康智能认知专家'
          }
        },
        {
          path: '/personCenter/paizheng',
          component: paizheng,
          meta: {
            title: '个人中心-心理问卷-吾征AI,您的健康智能认知专家'
          }
        },
        {
          path: "/personCenter/myOrder",
          component: myOrder,
          meta: {
            title: '个人中心-我的订单-吾征AI,您的健康智能认知专家'
          }
        },
        //个人中心-4-1-会员中心
        {
          path: '/personCenter/memberCenter',
          component: memberCenter,
          meta: {
            title: '个人中心-会员中心-吾征AI,您的健康智能认知专家'
          }
        },
        //个人中心-4-1-我的签到
        {
          path: '/personCenter/memberCenter/signrecord',
          component: signrecord,
          meta: {
            title: '个人中心-签到记录-吾征AI,您的健康智能认知专家'
          }
        },
        // 个人中心-4-1-推广主
        {
          path: '/personCenter/iamPromoter',
          component: iamPromoter,
          meta: {
            title: '个人中心-推广主-吾征AI,您的健康智能认知专家'
          }
        },
        {
          path: '/personCenter/iamPromoter/fsHistroyChange',
          component: fsHistroyChange,
          meta: {
            title: '个人中心-推广主-吾征AI,您的健康智能认知专家'
          }
        },
        {
          path: '/personCenter/iamPromoter/shouyichange',
          component: shouyichange,
          meta: {
            title: '个人中心-推广主-吾征AI,您的健康智能认知专家'
          }
        },
      ]
    },
  ],
})

router.beforeEach((to, from, next) => {
  //拦截指定路由
  // document.body.scrollTo(0, 0);
  $('body,html').animate({ scrollTop: 0 }, 500);
  next();

})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js